import React from 'react';
import Button from '@material-ui/core/Button';
import moment, { Moment } from 'moment';
import { TextField, createStyles, Theme, withStyles } from '@material-ui/core';
import AwbInfoSearchComponent from "../awbInfo/awbInfoSearch/AwbInfoSearchComponent";

import PrintIcon from '@material-ui/icons/Print';
import SearchIcon from '@material-ui/icons/Search';

import shipmentStyles from './shipmentInventory.module.css';
import commonStyles from '../common/common.module.css';

interface ShipmentInventoryFilterComponentProps {
  classes: any;
  startDate: Moment;
  endDate: Moment;
  startTime: Moment;
  awbNumber: string;
  endTime: Moment;
  keyword: string;
  currDate: boolean;
  orderType: string;
  errorKeyword: boolean;
  flightVal: string;
  handleChangeKeyword: (event: any) => void;
  handleOrderChange: (event: any) => void;
  search: () => void;
  print: () => void;
  handleClick: () => void;
  disabledDate: () => void;
  changeFocuses: () => void;
  flightFilter: Array<string>;
  handleChangeDate: (dateType: string, event: any) => void;
  buttonState: boolean;
};

const styles = (theme: Theme) =>

  createStyles({
    input: {
      width: '150px' 
    },
    blue: {
      color: 'var(--primaryblue)'
    },
    select: {
      width: '110px'
    },
    button: {
      width: '100px',
      height: '40px'
    },
    textField: {
      color: 'var(--primaryblue)',
    },
    disabled: {
      color: 'rgba(0, 0, 0, 0.26)'
    },
    textFieldsDisabled: {
      color: 'rgba(0, 0, 0, 0.26)'
    },
    datePicker: {
      width: '150px'
    },
    helperText: {
      color: 'red'
    },
    inputSize: {
      padding: '10px 14px',
      width: '330px',
    },
    textFieldLabel: {
      transform: 'translate(14px, 12px) scale(1)',
      fontSize: '14px'
    },
    manualEntryBtn: {
      margin: '10px 20px',
      width:'171px'
    },
    searchBtn: {
      borderRadius: '50%',
      padding: '0',
      minWidth: '37px',
      height: ' 37px',
      position: 'absolute',
      right: '0px',
      top:'0px',
      background: 'var(--primaryblue)',
      marginTop: '1px',
    },
    iconSearch: {
      fontSize: '22px !important',
      color:'white !important',
      fill:'white !important',
    },
    badge: {
      '&>span': { 
        marginTop: '11px',
        marginRight: '-17px'
      }
    }
  });

const shipmentInventoryFilterComponent = (props: ShipmentInventoryFilterComponentProps) => {

  const { startDate, endDate, startTime, endTime, keyword, classes, currDate, errorKeyword } = props;
  let colorsClass: string = currDate ? classes.disabled : classes.blue;
  let textFieldClass: string = currDate ? classes.textField : classes.textFieldsDisabled;

  return (
      <div>
        <div className={ shipmentStyles.filters }>
          <div className={ commonStyles.searchWrapperOuter }>
            <AwbInfoSearchComponent
              awbNumber={ props.awbNumber }
              label = 'AirwayBill'
              handleChangeAwbNumber={ props.handleChangeKeyword }
              search={ props.search }
              type='screening'
              buttonState={ props.buttonState }
            />
          </div>
          <div className={ shipmentStyles.buttonClass }>
            <Button onClick={ props.print } color='primary'>
              <PrintIcon className={ shipmentStyles.svgIcon } />
            </Button>
          </div>
        </div>
      </div>
    );
};

export default  withStyles(styles)(shipmentInventoryFilterComponent);
